import React from "react";
import StaffTable from "./StaffTable";
import { Staff } from "../types/staff";
import { TablePaginationProps } from "@mui/material";

interface StaffTableSectionProps {
  staffData: Staff[];
  filteredData: Staff[];
  onEdit: (staff: Staff) => void;
  onDelete: (id: string, name: string) => void;
  onPageChange: NonNullable<TablePaginationProps["onPageChange"]>;
  onRowsPerPageChange: NonNullable<TablePaginationProps["onRowsPerPageChange"]>;
  showDeletedStaffs: boolean;
}

const StaffTableSection: React.FC<StaffTableSectionProps> = ({ staffData, filteredData, onEdit, onDelete, showDeletedStaffs }) => {
  return (
    <div className="staff-table">
      <StaffTable staffData={staffData} filteredData={filteredData} onEdit={onEdit} onDelete={onDelete} showDeletedStaffs={showDeletedStaffs} />
    </div>
  );
};

export default StaffTableSection;
